const signalR = require("@microsoft/signalr");
import { mapState, mapMutations } from "vuex";
import { getCrashHistory } from "@/api";
import { configs } from "@/configs";

import historyGameColor from "./util/historyGameColor";
import _ from "underscore";
import Cookie from "@/utils/cookie";
import Overlay from "./components/Overlay";
import StickyBet from "./components/StickyBet";
import UiGameSidebar from "./components/ui-game-sidebar";
import CrashHomeGame from "@/partials/crash_box";
import CrashBet from "./components/crash-bet";
import VirtualScroller from './components/crash-bet/VirtualScroller.vue';
import SkeletonRect from './components/crash-bet/SkeletonRect.vue';

import truncateString from './util/truncateString'
import HorizontalScroll from '@/components/HorizontalScroll'

import { RecycleScroller } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

import CrashGame from './components/crash-game'




// game.crashPoint
export default {
	name: 'crash',

	components: {
		"crash-bet": CrashBet,
		SkeletonRect,
		Overlay,
		StickyBet,
		"ui-game-sidebar": UiGameSidebar,
		"crash-home-game": CrashHomeGame,
		HorizontalScroll,
		CrashGame,
		RecycleScroller,
		VirtualScroller
	},

	filters: {

	},


	data() {
		return {
			isLoading: false,
			tick: 1,
			gameCountDownData: {
				betAmount: 0,
				maxBetAmount: 1000,
				maxProfit: 10000,
				minBetAmount: 0.05,
				playersCount: 0,
				secondsLeft: "8.09",
				serverTimeStamp: 1714536664361
			},
			crashPoint: 0,
			allBetAmount: 0,
			playersCount: 0,
			gameId: null,
			privateHash: null,
			publicSeed: null,
			players: [],
			history: [],
			ownBet: null,
			CrashBet, //虚拟滚动组件循环对象
			crashHub: null,
			isCashOutLoading:false,
			gameState: {
				maxBetAmount: 1000,
				maxProfit: 10000,
				minBetAmount: 0.05,
				status: "NotStarted"
			},

			GAME_STATES: {
				NotStarted: 'NotStarted',
				Starting: 'Starting',
				InProgress: 'InProgress',
				Over: 'Over',
				Blocking: 'Blocking',
				Refunded: 'Refunded',
				Crash: 'Crash',
			},
			spectateTarget: {
				userId: 0,
				player: {},
				lootItems: null
			},
			enterAmount: ['0.25', '5', '10']
		};
	},
	watch: {
	},
	computed: {
		...mapState(["user"]),
		currencyType() {
			return Number(this.$route.meta?.currencyType ?? this.$route.query.currencyType ?? 0);
		},
		currencyTypeLabel() {
			if (this.currencyType === 1) return '欢乐豆';
			if (this.currencyType === 2) return '金豆';
			return '现金';
		},
		crashHistoryRouteName() {
			if (this.currencyType === 1) return 'happyCoinCrashHistory';
			if (this.currencyType === 2) return 'coin1CrashHistory';
			return 'crashHistory';
		},
		crashHistoryDetailRouteName() {
			if (this.currencyType === 1) return 'happyCoinCrashHistoryDetail';
			if (this.currencyType === 2) return 'coin1CrashHistoryDetail';
			return 'crashHistoryDetail';
		},
		sortedBets() {
			if (!Array.isArray(this.players) || this.players.length === 0) {
				return [];
			}

			const list = [...this.players].sort((a, b) => (b.betAmount || 0) - (a.betAmount || 0));

			// 如果包含当前登录用户，将自己提到第 1 位
			const indexOfSelf = list.findIndex(item => item.userId == this.user?.id);
			if (indexOfSelf !== -1) {
				const [self] = list.splice(indexOfSelf, 1);
				list.unshift(self);
			}

			return list;
		},
		mvpList() {
			if (!Array.isArray(this.players) || this.players.length === 0) {
				return [];
			}

			// 1. 筛选 status == 1 的玩家（同时返回新数组，避免直接修改原数据）
			const validPlayers = this.players.filter(player => player && player.status == 1);

			if (validPlayers.length === 0) {
				return [];
			}

			// 2. 按 stoppedAt 降序排序
			const sorted = validPlayers.sort((a, b) => b.stoppedAt - a.stoppedAt);

			// 3. 截取前 3 名
			const topRank = sorted.slice(0, 3);

			// 4. 领奖台 C 位排布：满 3 人时调整顺序为 [银牌(2nd), 金牌(1st), 铜牌(3rd)]
			if (topRank.length === 3) {
				const [first, second, third] = topRank;
				return [second, first, third];
			}

			return topRank;
		},
		allBalance() {
			if (this.currencyType === 1) return Number(this.user?.happyCoin || 0).toFixed(2);
			if (this.currencyType === 2) return Number(this.user?.coin1Available || 0).toFixed(2);
			return Number(this.user?.recycles || 0).toFixed(2);
		},
		crashOutPlayers() {
			if (!Array.isArray(this.players)) return {};

			const betsMap = {};

			this.players.forEach(p => {
				// 只有逃顶成功的玩家（后端 status === 1）才组装进去
				if (p.status === 1) {
					const key = p.userId;
					betsMap[key] = {
						id: p.userId,
						gameId: p.gameId,
						status: 'WON',
						stoppedAt: p.stoppedAt,
						betAmount: p.betAmount || 0,
						name: p.name || '玩家',
						avatar: p.avatar || ''
					};
				}
			});

			return betsMap;
		}
	},
	created() {
		this.fetchCrashHistory();
	},
	mounted() {
		this.initCrashHub();
		window.addEventListener("setItemEvent", this.handleStorageEvent);
	},




	beforeDestroy() {
		clearInterval(this.timer);
		window.removeEventListener("setItemEvent", this.handleStorageEvent);
		this.unbindCrashHubEvents();

	},

	methods: {

		...mapMutations(["setloginModal", 'setInfo']),

	async initCrashHub() {
		if (this.$crashHub.currencyType !== this.currencyType) {
			if (this.$crashHub.conn && this.$crashHub.conn.stop) await this.$crashHub.conn.stop();
			this.$crashHub.initHub(this.currencyType);
		}
			if (!this.$crashHub.conn) {
				return;
			}

			this.bindCrashHubEvents();

			this.$crashHub.onConnected = () => {
				console.log("onConnected => UpdatePlayers");
				this.invokeCrashHub("UpdatePlayers");
				this.invokeCrashHub("GameConfig");
				this.isLoading = true;
			};

			this.$crashHub.onReconnected = () => {
				console.log("onReconnected => UpdatePlayers");
				this.invokeCrashHub("UpdatePlayers");
				this.invokeCrashHub("GameConfig");
				this.isLoading = true;
			};

			if (this.$crashHub.conn.state == "Connected") {
				//连接存在
				console.log("Connected => UpdatePlayers");
				this.invokeCrashHub("UpdatePlayers");
				this.invokeCrashHub("GameConfig");
				this.isLoading = true;
			}
		},
		getCrashHubHandlers() {
			return {
				"GameConfig": this.gameConfig,
				"GameCountDown": this.gameCountDown,
				"UpdatePlayer": this.updatePlayer,
				"UpdatePlayers": this.updatePlayers,
				"GameStarting": this.gameStarting,
				"GameStarted": this.gameStart,
				"GameEnd": this.gameEnd,
				"GameTick": this.gameTick,
				"BetCashout": this.betCashout,
				"GameJoinError": this.joinError,
				"GameJoinSuccess": this.joinSuccess,
				"BetCashOutError": this.cashoutError,
				"Authenticate": this.authHandle,
				"PlayerLootUpdate": this.playerLootUpdate,
			};
		},

		bindCrashHubEvents() {
			if (!this.$crashHub.conn) {
				return;
			}

			const handlers = this.getCrashHubHandlers();
			Object.keys(handlers).forEach((eventName) => {
				this.$crashHub.conn.off(eventName, handlers[eventName]);
				this.$crashHub.conn.on(eventName, handlers[eventName]);
			});
		},

		unbindCrashHubEvents() {
			if (!this.$crashHub.conn) {
				return;
			}

			const handlers = this.getCrashHubHandlers();
			Object.keys(handlers).forEach((eventName) => {
				this.$crashHub.conn.off(eventName, handlers[eventName]);
			});
		},

		isCrashHubConnected() {
			return this.$crashHub.conn && this.$crashHub.conn.state === signalR.HubConnectionState.Connected;
		},

		async invokeCrashHub(method, ...args) {
			if (!this.isCrashHubConnected()) {
				console.warn(`Crash hub not connected, skip invoke for ${method}`);
				return;
			}

			try {
				await this.$crashHub.conn.invoke(method, ...args);
			} catch (error) {
				console.error(`Failed to invoke crash hub method ${method}`, error);
			}
		},

		handleStorageEvent(e) {
			if (e.key === "authToken") {
				console.log('setItemEvent', e)
				this.authenticateCrashHub(e.newValue);
			}
		},

		authHandle(res) {
			switch (res.code) {
				case "forced_logout":
					this.forceLogout()
					break
			}
		},

		forceLogout() { // 重复登录
			this.$swal('您的游戏已经在别的窗口登录').then(res => {
				if (res.isConfirmed) {
					location.href = '/official'
				}
			});
		},

		async fetchCrashHistory() {
			try {
				const data = await getCrashHistory({ pageIndex: 0, pageSize: 30, currencyType: this.currencyType });

				this.history = data?.data?.data


			} catch (error) {
				console.log("There was an error while loading crash schema:", error);
			}
		},

		joinGame() {
			const { betAmount, autoCashout } = this.$refs.sidebar
			console.log('joinGame,betAmount', betAmount)
			console.log('joinGame,allBalance', this.allBalance)

			if (betAmount * 1 > this.allBalance * 1) {
				this.$toast.error("余额不足");
				return
			}

			const autoCashoutInt = Math.round(Number(autoCashout) * 100);

			this.invokeCrashHub(
				"JoinGame",
				Number(betAmount),

				autoCashoutInt,
				0,
				true
			);
		},

		updatePlayer(data) {
			console.log('updatePlayer', data)
			this.allBetAmount = data.betAmountSum
			this.playersCount = data.playersCount

			this.$set(this.players, this.players.length, data.player)
			this.players = this.players.sort(function (a, b) {
				return b.betAmount - a.betAmount;
			});

			if (data.player.userId == this.user.id) {
				this.ownBet = data.player;
				console.error('ownBet',this.ownBet);
			}

			const indexOfSelf = this.players.findIndex(item => item.userId == this.user.id);

			if (indexOfSelf !== -1) {
				const [self] = this.players.splice(indexOfSelf, 1);
				this.players.unshift(self);
			}
			console.log('this.players.length', this.players.length)
		},
		gameConfig(data) {
			this.enterAmount = [ `${data.minBet}` , `${data.minBet*2}` , `${data.minBet * 5}`];
			this.gameState.maxProfit = data.maxProfit;
		},
		updatePlayers(data) {
			console.log('updatePlayers111', data)
			this.players = data.players;
			this.allBetAmount = data.betAmount;
			this.playersCount = data.playersCount;

			const player = this.players.find(p => p.userId == this.user.id);
			if (player) {
				this.ownBet = player;
			}

			if (this.spectateTarget.userId) {
				const target = this.players.find(p => p.userId == this.spectateTarget.userId);
				if (target) {
					this.spectateTarget.player = target;
				}
			} else{
				if(this.players.length > 0 ){
					this.spectateTarget.userId = this.players[0].userId;
					this.spectateTarget.player = this.players[0];
				}
					
			}

			this.isLoading = false;

		},
		playerLootUpdate(data) {
			if (!data || !data.userId) return;

			// 1. 找到 players 列表中对应的玩家并全量覆盖
			const player = this.players.find(p => p.userId == data.userId);
			if (player) {
				this.$set(player, 'lootItems', data.items || {});
			}

			// 2. 关键：如果是当前观战的人，必须给 spectateTarget 也同步覆盖更新！
			// 解决因为 this.players 被替换导致 spectateTarget.player 变成旧引用问题
			if (this.spectateTarget.userId == data.userId) {
				if (this.spectateTarget.player) {
					this.$set(this.spectateTarget.player, 'lootItems', data.items || {});
				}
				// 如果你的观战组件直接绑定了 spectateTarget.lootItems，也一起覆盖
				this.$set(this.spectateTarget, 'lootItems', data.items || {});
			}
		},
		gameCountDown(data) {
			this.gameCountDownData = Object.assign({}, this.gameCountDownData, data)

			this.$set(this.gameState, 'maxBetAmount', data.maxBetAmount);
			this.$set(this.gameState, 'minBetAmount', data.minBetAmount);
			this.$set(this.gameState, 'maxProfit', data.maxProfit);
			// 1. 获取最小下注金额
			const min = Number(data.minBetAmount) || 0;
			this.enterAmount = [
				min,
				Number((min * 2).toFixed(2)),
				Number((min * 4).toFixed(2))
			];

			clearInterval(this.timer);
			this.startCountdown()
		},

		// New round is starting handler
		gameStarting(data) {
			this.fetchCrashHistory()
			console.log('gameStarting', data)
			this.gameId = data.id;
			this.privateHash = data.privateHash;
			this.allBetAmount = 0
			this.playersCount = 0
			this.publicSeed = null;
			this.players = [];
			this.isCashOutLoading = false;
			this.ownBet = null;
			this.spectateTarget = {
				userId: 0,
				player: {}
			};
			this.tick = 1;
			this.$set(this.gameState, 'status', this.GAME_STATES.Starting);

			const { setAutoBetMinus, autoBet } = this.$refs.sidebar

			if (autoBet > 0) {
				this.clickBet()

				setAutoBetMinus()
			} else {

			}

		},

		gameStart(data) {

			console.log('gameStart', data)
			this.$set(this.gameState, 'status', this.GAME_STATES.InProgress)

			this.publicSeed = data.publicSeed;


			if (this.ownBet) {
				this.spectateTarget.userId = this.user.id;
				const player = this.players.find(p => p.userId == this.user.id);
				this.spectateTarget.player = player;
			} else {

				if (this.players.length > 0) {
					
					this.spectateTarget.userId = this.players[0].userId;
					this.spectateTarget.player = this.players[0];

					console.log('this.spectateTarget' , this.spectateTarget)
				}
			}

		},
		// Current round tick handler
		gameTick(data) {

			this.$set(this.gameState, 'status', this.GAME_STATES.InProgress)
			this.tick = data.tick;

			var { autoCashout } = this.$refs.sidebar;

			const curTick = Number(data.tick);
			const curAutoCashOut =  Number(autoCashout);

			if(this.ownBet 
				&&this.ownBet.gameId != data.gameId)
				this.ownBet = null;

			if (this.ownBet 
				&& !this.ownBet.winningAmount 
				&& autoCashout 
				&& curTick >= curAutoCashOut ) {
				this.cashout(); 

				console.log( '测试 自动收取时间' , curAutoCashOut );
				console.log( '测试 自动收取tick' , curTick );
			}
		},

		betCashout(bet) {

			if (this.user.id == bet.userId) {
				console.log('撤退消息 betCashout2333', bet)
				this.ownBet = bet;
				this.setInfo();

				this.isCashOutLoading = false;
			}

			if (this.spectateTarget.userId == bet.userId) {
				this.spectateTarget.player = bet;
			}

			const player = this.players.find(p => p.userId == bet.userId);
			if (player) {
				Object.assign(player, bet); // Vue 中直接修改对象属性是响应式的
			}

			console.log('撤退消息 this.players', this.players)

		},

		gameEnd(data) {

			console.log('gameEnd', data)


			this.crashPoint = data.crashPoint / 100.0;

			if (this.crashPoint <= 1.05) {
				this.$set(this.gameState, 'status', this.GAME_STATES.Crash)
			} else {
				this.$set(this.gameState, 'status', this.GAME_STATES.Over)
			}

			this.players = data.players;

			console.log('mvpList', this.mvpList);

			this.setInfo()
		},

		joinError(msg) {
			console.log('joinError', msg)
			this.$toast.error(msg);
		},


		joinSuccess(msg) {
			this.$toast.success(msg);
			this.setInfo();
		},

		cashoutError(msg) {
			console.log('cashoutError', msg)
			this.$toast.error(msg);
			this.isCashOutLoading = false;
		},

		clickBet() {
			if (!this.user.nickname) {
				this.setloginModal(true);
				return
			}

			const { betAmount } = this.$refs.sidebar;

			if (Number(betAmount) <= 0) return;

			if (this.gameState.status === this.GAME_STATES.Starting) {
				this.joinGame()
			}
		},

		cashout() {

			if(this.isCashOutLoading == true)return;

			this.isCashOutLoading = true;
			// Emit bet cashout
			this.invokeCrashHub("CashOut", this.tick);

		},
		handleSpectate(userId) {
			if (this.ownBet) {
				this.spectateTarget.userId = this.user.id;
			} else {
				
				if (this.players.length > 0) {
					const player = this.players.find(item => item.userId == userId);
					console.log('test1111111:',player);
					if (player) {
						this.spectateTarget.userId = player.userId;
						this.spectateTarget.player = player;
					}

				}
			}
		},
		historyGameColor,

		startCountdown() {
			// 设置倒计时间隔为100毫秒，每100毫秒更新一次倒计时值
			this.timer = setInterval(() => {
				// 如果倒计时值大于0，每100毫秒减少0.01

				if (this.gameCountDownData.secondsLeft > 0) {
					this.$set(this.gameCountDownData, 'secondsLeft', (this.gameCountDownData.secondsLeft - 0.01).toFixed(2))
				} else {
					// 如果倒计时值小于等于0，停止倒计时
					clearInterval(this.timer);
					this.$set(this.gameCountDownData, 'secondsLeft', 0.00)
				}
			}, 10);
		},
		copyText() {
			this.$copyText(this.privateHash).then(
				e => {
					console.log('复制成功：', e);
				},
			)
		},
		truncateString
	}
}
